var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.updates !== null)?[_vm._l((_setup.updates),function(log,index){return _c(_setup.StartupUpdateLog,{key:index,attrs:{"log":log,"index":index}})}),_c(_setup.ScrolledBottom,{on:{"scrolledBottom":_setup.scrolledBottom}})]:_vm._e(),(_setup.loading)?_c(_setup.Loader,{attrs:{"loading":true}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }